import { useState } from 'react';

import {
  Button,
  ButtonBasicProps
} from '@deliveryhero/pd-cookbook/components/ButtonV2';
import { Tooltip } from '@deliveryhero/pd-cookbook/components/Tooltip';

import { format, parseISO } from 'date-fns';

import { ButtonWithTooltipProps } from './types';

export default function ButtonWithTooltip({
  isDisabled,
  lastSentOn,
  toolTipText,
  displayOnlyWhenDisabled = false,
  ...buttonProps
}: ButtonWithTooltipProps & ButtonBasicProps) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const bodyText = toolTipText
    ? toolTipText
    : lastSentOn
    ? `You can send this once every 24 hours. Last sent on ${format(
        parseISO(lastSentOn),
        'MMM d, hh:mm a'
      )}`
    : '';

  const { children, ...rest } = buttonProps;
  return (
    <div
      onMouseEnter={() =>
        displayOnlyWhenDisabled
          ? isDisabled && setIsTooltipOpen(true)
          : setIsTooltipOpen(true)
      }
      onMouseLeave={() => setIsTooltipOpen(false)}
    >
      <Tooltip
        isVisibleForAnimation={isTooltipOpen}
        arrowAlignment="left"
        bodyText={bodyText}
        placement="right"
      >
        <Button
          variant="text"
          layout="full-width-secondary"
          type="button"
          disabled={isDisabled}
          {...rest}
        >
          {children}
        </Button>
      </Tooltip>
    </div>
  );
}
